(() => {
  if (customElements.get('component-models')) {
    return;
  }

  class ComponentModels extends customElements.get('slider-default') {
    constructor() {
      super();

      this.counterCurrent = this.querySelector('.js-counter-current');
      this.sliderTitles = this.querySelector('.js-slider-titles');
      this.titleEl = this.querySelector('.js-title');
      this.colorNavElements = this.querySelectorAll('.js-models-nav input');

      this.slider.on('slideChange', (slider) => {
        const activeSlide = Array.from(slider.slides).find(
          (slide) => +slide.dataset.swiperSlideIndex === slider.realIndex,
        );
        const activeSlideTitle = activeSlide.dataset.title;

        if (this.counterCurrent) {
          const index = ++slider.realIndex;

          this.counterCurrent.textContent = index >= 10 ? index : `0${index}`;
        }

        if (!this.sliderTitles) return;

        this.titleEl.textContent = activeSlideTitle;

        const activeTitle = this.sliderTitles.querySelector(
          '.js-slider-title.is-active',
        );
        const newActiveTitle = this.sliderTitles.querySelector(
          `.js-slider-title[data-title="${activeSlideTitle}"]`,
        );

        activeTitle.classList.remove('is-active');
        newActiveTitle?.classList.add('is-active');
      });

      window.addEventListener('load', this.init.bind(this));
    }

    init() {
      this.allSlides = Array.from(this.querySelectorAll('.js-slides .swiper-slide'));
      this.slideWrapper = this.querySelector('.js-slides');

      this.slideHolder = document.createElement('div');
      this.slideHolder.style.display = 'none';
      this.appendChild(this.slideHolder);

      const defaultToggle = this.querySelector('.models__view-toggle input:checked');
      if (defaultToggle) {
        this.filterSlides(defaultToggle.value);
      }

      this.initFlicking();

      this.colorNavElements.forEach((colorNavItem) => {
        colorNavItem.addEventListener('change', () => {
          this.querySelectorAll('.js-models-nav input:checked').forEach(
            (activeElement) => (activeElement.checked = false),
          );
          colorNavItem.checked = true;
          const colorGroup = colorNavItem.dataset.colorGroup;
          const panelIndex = this.flicking.panels.findIndex(
            (p) => p.element.dataset.groupColor === colorGroup,
          );
          if (panelIndex !== -1) this.flicking.moveTo(panelIndex);
        });
      });

      this.querySelectorAll('.models__view-toggle input').forEach((input) => {
        input.addEventListener('change', () => {
          if (this.flicking) {
            this.flicking.destroy();
            this.flicking = null;
          }
          // Restore all slides to the wrapper before re-filtering
          Array.from(this.slideHolder.children).forEach((slide) => {
            this.slideWrapper.appendChild(slide);
          });
          this.filterSlides(input.value);
          this.initFlicking();
        });
      });
    }

    filterSlides(filter) {
      this.allSlides.forEach((slide) => {
        const pattern = (slide.dataset.colorPattern || '').trim();
        const show = filter === 'solid' ? pattern === 'solid' : pattern !== 'solid';
        if (!show) this.slideHolder.appendChild(slide);
      });

      this.querySelectorAll('.models__nav li[data-color-pattern]').forEach((li) => {
        const pattern = (li.dataset.colorPattern || '').trim();
        const show = filter === 'solid' ? pattern === 'solid' : pattern !== 'solid';
        li.style.display = show ? '' : 'none';
      });
    }

    initFlicking() {
      const sliderEl = this.querySelector('.js-slider-flick');
      const events = Flicking.EVENTS;
      const counterCurrent = this.querySelector('.js-counter-current');
      const sliderTitle = this.querySelector('.js-models-title');
      const titleEl = sliderTitle.querySelector('h4');
      const sliderSubTitle = this.querySelector('.js-variant-title');
      const subTitleEl = sliderSubTitle.querySelector('h4');

      this.flicking = new Flicking(sliderEl, { circular: true, align: 'center' });

      window.addEventListener('orientationchange', () => {
        this.flicking?.resize();
      });

      const panelsScale = () => {
        this.flicking.visiblePanels.forEach((panel) => {
          const progress = Math.abs(panel.outsetProgress);
          const el = panel.element;
          const media = el.querySelector('.models__media');

          let scale = Math.abs(1 - progress);
          if (scale < 0.8) scale = 0.8;

          media.style.transform = `scale(${scale})`;
        });
      };

      const getCenterSlide = (event) => {
        const slides = event.currentTarget.visiblePanels.filter(
          (panel) =>
            Math.abs(event.currentTarget._camera._position - panel.position) <
            panel._size - 28,
        );
        slides.sort((a, b) => {
          const pos = a._flicking._camera._position;
          return Math.abs(pos - a.position) - Math.abs(pos - b.position);
        });
        return slides[0];
      };

      this.flicking.on(events.READY, (event) => {
        panelsScale();
        this.flicking.resize();

        const currentSlide = getCenterSlide(event);
        event.currentTarget.panels.forEach((panel) => {
          panel.element.classList.toggle('swiper-slide--center', panel.element === currentSlide.element);
        });
      });

      this.flicking.on(events.MOVE_END, (event) => {
        panelsScale();

        const currentSlide = getCenterSlide(event);
        event.currentTarget.panels.forEach((panel) => {
          panel.element.classList.toggle('swiper-slide--center', panel.element === currentSlide.element);
        });

        const currentColorGroup = currentSlide._elProvider._element.dataset.groupColor;

        this.querySelectorAll('.js-models-nav input').forEach((input) => (input.checked = false));

        const currentColorNavSwatch = this.querySelector(
          `.js-models-nav input[data-color-group="${currentColorGroup}"]`,
        );
        if (currentColorNavSwatch) currentColorNavSwatch.checked = true;
      });

      this.flicking.on(events.MOVE, (event) => {
        panelsScale();

        const currentSlide = getCenterSlide(event);

        event.currentTarget.panels.forEach((panel) => {
          panel.element.classList.toggle('swiper-slide--center', panel.element === currentSlide.element);
        });

        const el = currentSlide._elProvider._element;

        if (counterCurrent) {
          const index = Number(currentSlide._index) + 1;
          counterCurrent.textContent = index >= 10 ? index : `0${index}`;
        }

        if (!sliderTitle) return;

        titleEl.style.color = el.dataset.color;
        titleEl.textContent = el.dataset.title;

        if (!subTitleEl) return;

        if (el.dataset.subTitle !== '') {
          subTitleEl.classList.remove('hidden');
          subTitleEl.style.color = el.dataset.colorSecond;
          subTitleEl.textContent = el.dataset.subTitle;
        } else {
          subTitleEl.classList.add('hidden');
        }
      });

    }
  }

  customElements.define('component-models', ComponentModels);
})();
